export default __webpack_public_path__ + "static/media/watch.5c91ab49.png";